import 'babel-polyfill'
import Vue from 'vue'

import Element from 'element-ui'
import './assets/css/element/index.css'

import storage from '@/utils/storage'

Vue.use(Element);
// 统一提示
const tipMap = {
    1: "success",
    2: "warning",
    3: "info",
    4: "error",
}

window.VueTips = Vue.prototype.$tip = function (title, type, duration, customClass) {
    if (window.tipsModel) {
        window.tipsModel.close()
        window.tipsModel = null;
    }
    let tips = Vue.prototype.$message({
        message: title || '',
        type: tipMap[type] || type || 'success',
        duration: duration || 3000,
        customClass: customClass || ''
    });
    window.tipsModel = tips
}

// 请求
import depot from '@/utils/http'
depot()

import App from './App'
import router from './router'
import { util } from "./utils/common"
import tools from "./utils/tools"

import bus from './utils/bus.js'

//cpInput:经过调校的input，默认使用trim，默认限制字数50，其他特殊功能
// import cpInput from '@/components/input/cpInput'
// import tableLayout from '@/components/tableLayout/tableLayout'

// 过滤器
import * as filters from './filters'

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

import store from './store'

// Vue.component('cp-input', cpInput)
// Vue.component('tableLayout', tableLayout)


Vue.use(tools);
Vue.use(bus);
Vue.prototype.$utils = util
window.$storage = storage

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js